module.exports = __webpack_public_path__ + "img/zhipu.e50587af.png";